module.exports = __webpack_public_path__ + "img/jingcai_en.3605a18.png";